import { FC, ReactNode } from 'react';

import Footer from './Footer';
import ProjectsTopBar from './ProjectsTopBar';
import { Toaster } from 'sonner';

interface DefaultLayoutProps {
    children: ReactNode;
    onNewProject?: () => void;
    onOpenProject?: () => void;
    onOpenPreview?: () => void;
}

const DefaultLayout: FC<DefaultLayoutProps> = ({ 
    children,
    onNewProject,
    onOpenProject,
    onOpenPreview,
}) => {
    return (
        <div className="flex flex-col h-screen">
            <ProjectsTopBar
                onNewProject={onNewProject}
                onOpenProject={onOpenProject}
                onOpenPreview={onOpenPreview}
            />
            <main className="flex-1 overflow-auto px-8">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default DefaultLayout; 